<template>
    <div>
        <!-- <v-card class="pa-2 ma-3">
            <v-select
                style="width: 300px;"
                label="Shared By"
                :items="sharedByList"
                v-model="sharedBy"
                hide-details
                class="ma-2"
                outline
                @change="sharedByChanged"
                clearable
            ></v-select>
        </v-card> -->
        <div v-if="!loading && !filesToDisplay.length">
            <v-card class="pa-3 ma-3">
                <div class="headline text-xs-center">No Files</div>
            </v-card>
        </div>
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
            class="ma-3 pl-3"
        ></v-progress-linear>
        <v-layout row wrap class="ma-2" v-if="!loading">
            <div class="shared-file" v-for="file in filesToDisplay">
                <v-layout row justify-center>
                    <v-icon
                        class="mr-3 ml-1 mt-0"
                        dark
                        large
                        :color="getFileIconColor(file)"
                        >{{ getFileIcon(file) }}</v-icon
                    >
                </v-layout>
                <div
                    :title="file.fileName"
                    class="caption font-weight-regular text-xs-center mt-2"
                >
                    {{ truncateText(file.fileName) }}
                </div>
                <div class="caption font-weight-light text-xs-center mt-2">
                    <span class="font-weight-regular">Shared By:</span>
                    {{ file.uploadedBy }}
                </div>
                <div class="caption font-weight-light text-xs-center mt-2">
                    <span class="font-weight-regular">Expiration:</span>
                    {{ file.expirationDate | date }}
                </div>
                <div
                    v-if="file.instruction"
                    style="-webkit-box-orient: unset !important"
                    class="caption font-weight-light text-xs-center mt-2"
                >
                    <span class="font-weight-regular">Instruction:</span>
                    {{ file.instruction }}
                </div>
                <v-layout row justify-center>
                    <v-btn
                        class="text-xs-center mb-2"
                        small
                        outline
                        color="success"
                        @click="downloadFile(file)"
                        ><v-icon left>mdi-cloud-download</v-icon
                        ><span style="padding-top: 3px;">Download</span></v-btn
                    >
                </v-layout>
            </div>
        </v-layout>
    </div>
</template>

<script>
import moment from "moment";
import { truncate, pluralize, onlyUnique } from "../../utils/helpers.js";

export default {
    data: () => ({
        files: [],
        filesToDisplay: [],
        sharedByList: [],
        sharedBy: "",
        loading: true,

        rules: {
            required: (value) => !!value || "Required.",
        },
    }),
    async created() {
        this.loadFiles();
    },
    watch: {},
    beforeDestroy() {},
    methods: {
        async loadFiles() {
            try {
                this.files = await this.$http.get(
                    "api/sharedFiles/getFilesSharedWithUser?user=" +
                        this.$store.state.authentication.user,
                );

                this.filesToDisplay = this.files;
                this.sharedByList = this.files
                    .map((f) => f.uploadedBy)
                    .filter(onlyUnique);

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        sharedByChanged(value) {
            if (!value) {
                this.filesToDisplay = this.files;

                return;
            }

            this.filesToDisplay = this.files.filter((f) =>
                f.uploadedBy.includes(value),
            );
        },
        getFileIcon(file) {
            switch (this.getFileType(file.url)) {
                case "pdf":
                    return "mdi-file-pdf";
                case "docx":
                    return "mdi-file-word";
                case "xls":
                case "xlsx":
                    return "mdi-file-excel";
                case "mp3":
                case "wav":
                case "wma":
                    return "mdi-play-box-outline";
                case "jpg":
                case "png":
                case "gif":
                    return "mdi-image-area";
                case "zip":
                    return "mdi-zip-box";
                default:
                    return "mdi-file";
            }
        },
        getFileIconColor(file) {
            switch (this.getFileType(file.url)) {
                case "pdf":
                    return "#ad0b00";
                case "docx":
                    return "#295293";
                case "xls":
                case "xlsx":
                    return "#107a44";
                case "mp3":
                case "wav":
                case "wma":
                    return "purple";
                case "jpg":
                case "png":
                case "gif":
                    return "#ff755a";
                case "zip":
                    return "#f7cc4c";
                default:
                    return "blue";
            }
        },
        getFileType(url) {
            const parsedUrl = new URL(url);
            const path = parsedUrl.pathname;
            const match = path.match(/\.([^.?#]+)(?:[?#]|$)/);

            // If no match, return null
            if (!match) return null;

            const extension = match[1].toLowerCase();
            return extension.length > 5 ? null : extension.toLowerCase();
        },
        truncateText(fileName) {
            return truncate(fileName, 30);
        },
        async downloadFile(file) {
            try {
                const response = await fetch(file.url);
                if (!response.ok)
                    throw new Error("Network response was not ok");

                const blob = await response.blob();
                const link = document.createElement("a");
                const blobUrl = window.URL.createObjectURL(blob);

                link.href = blobUrl;
                link.download = file.fileName; // Default filename if none provided
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Download failed:", error);
            }
        },
    },
};
</script>
<style>
.shared-file {
    width: 150px;
    background-color: #fff;
    margin: 8px;
    padding: 12px;
    border-radius: 5px;
}
.shared-file .caption {
    word-break: break-word; /* Wraps long words */
    white-space: normal; /* Allows wrapping */
    max-width: 100%; /* Keeps it within container */
    overflow: hidden; /* Hides excess text */
    text-overflow: ellipsis; /* Adds "..." for truncated text */
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limits to 2 lines */
    -webkit-box-orient: vertical;
}
</style>
